import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import {
  authServiceMiddlewareCreator,
  notificationMiddlewareCreator,
  successAction,
  types,
} from "@authzsvc/api-lib";
import * as cfg from "./config";

const messages = Object.freeze({
  [successAction(types.ADD_ROLE)]: "Role created successfully!",
  [successAction(types.ADD_APPLICATION)]: "Application created successfully!",
  [successAction(types.DELETE_APPLICATION)]:
    "Application deleted successfully!",
  [successAction(types.UPDATE_REGISTRATION)]:
    "Application registration updated successfully!",
  [successAction(types.PUT_TOKEN_EXCHANGE_REQUEST_WITH_BODY_PARAMS)]:
    "Token exchange request successfully created! The owner(s) might have to approve it, if you do not have permissions to modify the application",
  [successAction(types.DELETE_TOKEN_EXCHANGE_PERMISSION)]:
    "Token exchange permission deleted successfully!",
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // "keycloak" instances were not serializable, so they had to temporarily be ignored

        // Ignore these action types dispatched by KeycloakWrapper
        ignoredActions: [
          "keycloak/setKeycloak",
          "keycloak/setKeycloakAuthenticated",
          "keycloak/setKeycloakReady",
          "keycloak/setUserToken",
        ],
        // Ignore these paths in state where non-serializable data lives
        ignoredPaths: ["keycloak.instance"],
      },
    }).concat([
      authServiceMiddlewareCreator(cfg),
      notificationMiddlewareCreator(messages),
    ]),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
